const getObjectPath = (obj: {}, path: string) => path.split(".").reduce((value: any, el: any) => value[el], obj);

export default getObjectPath;
